

export function is_on_localhost(): boolean
{
    return window.location.hostname === "localhost"
}

export function is_on_wikisim(): boolean
{
    return window.location.hostname === "wikisim.org"
}

export function is_on_ajamesphillips(): boolean
{
    return window.location.hostname === "ajamesphillips.com"
}
